import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Benefits } from "@/components/Benefits";
import { Features } from "@/components/Features";
import { Prototypes } from "@/components/Prototypes";
import { Stats } from "@/components/Stats";
import { GrowthVision } from "@/components/GrowthVision";
import { PreorderCTA } from "@/components/PreorderCTA";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative z-10 bg-stone-50 overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <Benefits />
      <Features />
      <Prototypes />
      <Stats />
      <GrowthVision />
      <PreorderCTA />
      <Footer />
    </main>
  );
}
